import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Read from React Router's location.hash (reactive) so the callback doesn't get stuck
    // after history.replaceState clears the fragment.
    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/"); return; }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState({}, "", window.location.pathname);
        // Send new (unverified) users to the one-time identity check first
        const dest = data.user?.kyc_status && data.user.kyc_status !== "unverified" ? "/" : "/verify";
        nav(dest, { replace: true, state: { user: data.user } });
      } catch {
        nav("/");
      }
    })();
  }, [nav, setUser, loc.hash]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-sand">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-copper border-t-transparent" />
        <p className="mt-4 font-display text-lg font-semibold text-slate-800">Signing you in…</p>
      </div>
    </div>
  );
}
